import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { GettingStartedPanelComponent } from './getting-started-panel.component'

@NgModule({
  imports: [CommonModule],
  declarations: [GettingStartedPanelComponent],
  exports: [GettingStartedPanelComponent],
})
export class GettingStartedModule {}

export { GettingStartedPanelComponent }
